import {post} from 'aws-amplify/api';
import {Command, type PostMethod} from '../../Command';

export class RemoveAccountUserCommand extends Command<PostMethod> {
  constructor() {
    super(post, {
      path: '/me/removeaccount',
      // Amplify rejoue par défaut un POST sur 5xx, 429 ou erreur réseau. Une suppression de
      // compte ne se rejoue pas en douce : l'utilisateur réessaie lui-même s'il le faut.
      options: {retryStrategy: {strategy: 'no-retry'}},
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<void> {
    await output.response;
  }
}
